import classNames from "classnames";

interface Props {
  table?: boolean;
}

const EmptyField = ({ table = false }: Props) => {
  return <span className={classNames({ "text-transparent": table })}>--</span>;
};

export default EmptyField;
